import InputNumber from 'components/InputNumber'
import cn from 'classnames'
import s from './InputNumberDouble.module.scss'

interface Props {
  labelStart: string
  labelMid: string
  labelEnd: string
  leftInput: {
    value: number | string | null
    onChange: (newValue: number) => void
    placeholder?: string
  }
  rightInput: {
    value: number | string | null
    onChange: (newValue: number) => void
    placeholder?: string
  }
  disabled?: boolean
}

const defaultProps = {
  disabled: false,
}

const InputNumberDouble = ({
  labelStart,
  labelMid,
  labelEnd,
  leftInput,
  rightInput,
  disabled,
}: Props): JSX.Element => (
  <div className={cn('input-number-double', s.inputNumberDouble)}>
    <span>{labelStart}</span>
    <InputNumber
      className={s.inputNumber}
      value={leftInput.value || ''}
      onChange={leftInput.onChange}
      disabled={disabled}
      placeholder={leftInput.placeholder}
    />
    <span>{labelMid}</span>
    <InputNumber
      className={s.inputNumber}
      value={rightInput.value || ''}
      onChange={rightInput.onChange}
      disabled={disabled}
      placeholder={rightInput.placeholder}
    />
    <span>{labelEnd}</span>
  </div>
)

InputNumberDouble.defaultProps = defaultProps
export default InputNumberDouble
